import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Silo, SiloDistributionTypes } from '@next/core-lib/cart';

export const validateSiloDistribution = (control: AbstractControl): ValidationErrors | null => {
  const silos: Silo[] = control.get('silos').value;
  const orderQuantity: number = control.get('quantity').value;

  if (!silos || !orderQuantity) {
    return null;
  }

  const isExact = silos.some((s) => s.distributionType === SiloDistributionTypes.exact);

  if (!isExact) {
    return null;
  }

  return silos.reduce((a, c) => (a += c.quantity), 0) !== orderQuantity ? { invalidSiloDistribution: true } : null;
};
